import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import AddressDisplay from 'common/components/address/AddressDisplay';
import { Layout, Title, Pagination } from 'common/components/layout';
import {
  concatUrlString,
  pageFromQuery,
  urlPushQuery,
  queryStringFromProps
} from 'common/helpers/searchHelper';
import SubMenu from 'profile/common/SubMenu';
import { listClubMemberships } from 'redux/clubMemberships/actions';
import { getActiveClubMemberships } from 'redux/clubMemberships/reducers';
import {
  listCustomerAddresses,
  resetCustomerAddressQuery
} from 'redux/customerAddresses/actions';

import ClubAddress from './components/ClubAddress';
import DefaultAddress from './components/DefaultAddress';

class AddressList extends Component {
  componentDidMount() {
    const { props } = this;
    props.resetCustomerAddressQuery();
    const urlString = queryStringFromProps(props);
    props.listCustomerAddresses(urlString);
    props.listClubMemberships();
  }

  search = (page) => {
    const { props } = this;
    props.resetCustomerAddressQuery();
    const urlString = concatUrlString(page);
    props.listCustomerAddresses(urlString);
    props.history.push(urlPushQuery('/profile/address-book', urlString));
  };

  render() {
    const { location, settings, customerAddresses } = this.props;
    const { activeClubMemberships } = this.props;
    const page = pageFromQuery(location.search);
    if (
      !settings.data ||
      !customerAddresses.data ||
      customerAddresses.query === null
    ) {
      return (
        <Layout title="Address Book" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }

    const displayArray = arrayOf2(customerAddresses.query);
    return (
      <Layout title="Address Book">
        <Title>Your Account</Title>
        <SubMenu />

        <div className="c7-account__address-book">
          <h2>Address Book</h2>

          {displayArray.map((innerArray) => (
            <div key={innerArray[0]} className="c7-account-row">
              {innerArray.map((addressId) => {
                const address = customerAddresses.data[addressId];
                return (
                  <div key={address.id} className="c7-account-tile">
                    <AddressDisplay address={address} boldName />
                    <br />
                    <DefaultAddress
                      address={address}
                      addressCount={customerAddresses.query.length}
                    />
                    <ClubAddress
                      address={address}
                      activeClubMemberships={activeClubMemberships}
                    />
                    <Link
                      to={`/profile/address-book/${address.id}`}
                      className="c7-button-alt-small"
                    >
                      Edit
                    </Link>
                  </div>
                );
              })}
            </div>
          ))}

          <Pagination
            totalRecords={customerAddresses.recordCount}
            page={page || 1}
            search={this.search}
          />

          <div className="c7-account-row c7-account-row--add">
            <Link to="/profile/address-book/add" className="c7-button-small">
              Add a new address
            </Link>
          </div>
        </div>
      </Layout>
    );
  }
}

const arrayOf2 = (array) => {
  const arrayOutput = [];
  let innerArray = [];
  if (!array) {
    return arrayOutput;
  }
  array.forEach((element, index) => {
    innerArray.push(element);
    if ((index + 1) % 2 === 0) {
      arrayOutput.push(innerArray);
      innerArray = [];
    }
  });
  if (innerArray.length > 0) {
    arrayOutput.push(innerArray);
  }
  return arrayOutput;
};

const mapStateToProps = (state) => ({
  customerAddresses: state.customerAddress,
  settings: state.setting,
  activeClubMemberships: getActiveClubMemberships(state.clubMembership)
});

export default connect(mapStateToProps, {
  listCustomerAddresses,
  resetCustomerAddressQuery,
  listClubMemberships
})(AddressList);
